import React from 'react';
import {view} from '@sail/ui';
import type {SupportedNetwork} from '@stripe-internal/wallet-connect-wrapper';
import type {WalletOption, ExchangeOption} from 'src/v2/state/types';
import {NetworkBadge} from 'src/v2/components/wallet/NetworkBadge';
import {WalletInfo} from 'src/v2/components/wallet/WalletInfo';
import {BaseCard} from 'src/v2/components/common/BaseCard';

interface WalletCardProps {
  wallet: {
    option: WalletOption | ExchangeOption;
    address?: string;
    network?: SupportedNetwork;
  };
  headerActions?: React.ReactNode;
  bottomContent: React.ReactNode;
  hideNetworkBadge?: boolean;
}

export const WalletCard: React.FC<WalletCardProps> = ({
  wallet: {option, address, network},
  headerActions,
  bottomContent,
  hideNetworkBadge = false,
}) => {
  const header = (
    <>
      <WalletInfo walletOption={option} address={address} />

      <view.div css={{stack: 'x', gap: 'small', alignItems: 'center'}}>
        {/* Network Badge */}
        {!hideNetworkBadge && network ? (
          <NetworkBadge network={network} />
        ) : null}

        {headerActions}
      </view.div>
    </>
  );

  return <BaseCard header={header}>{bottomContent}</BaseCard>;
};
